import { BaseSettings } from 'Shared/frontend/themes/BaseSettings';


export class PablosSettings extends BaseSettings
{
}
